// @flow
// @jsx h

import { h } from 'preact';

import styles from './PrimaryButton.scss';
import themeMarketplace from './theme-marketplace.scss';
import themeKiosk from './theme-kiosk.scss';
import {ThemeConfig} from "elc-theme"

import Button from './Button';

/**
 * Common Button stateless functional Component
 */
const PrimaryButton = (
  {
    type,
    handleClick,
    disabled,
    children,
    className,
    inverse
  }: {
    type?: string,
    handleClick?: Function,
    disabled?: boolean,
    children?: any,
    className?: string,
    inverse?: boolean
  },
  context
) => {
  const theme =
    context.widgetContext === 'KIOSK'
      ? themeKiosk
      : context.widgetContext === 'SHOP' || context.widgetContext === 'PMS'
        ? themeMarketplace
        : undefined;

  let computedClassName = '';
  if (className) {
    computedClassName += className;
  }
  computedClassName += ` ${
    theme && theme.primaryButton ? theme.primaryButton : styles.primaryButton
  } ${
    inverse
      ? theme && theme.primaryButtonInverse
        ? theme.primaryButtonInverse
        : styles.primaryButtonInverse
      : ''
  }`;
  return (
    <ThemeConfig.Consumer>
      { themeConfig => {
         return(
    <Button
      type={type || 'button'}
      handleClick={handleClick}
      disabled={disabled}
      className={computedClassName}
      background={!inverse && themeConfig && themeConfig.color2 ? themeConfig.color2 : ''}
      color={inverse && themeConfig && themeConfig.color2 ? themeConfig.color2 : ''}
      borderColor={inverse && themeConfig && themeConfig.color2 ? themeConfig.color2 : ''}
    >
      <span
        class={
          theme && theme.buttonContentWrapper
            ? theme.buttonContentWrapper
            : styles.buttonContentWrapper
        }
      >
        {children}
      </span>
    </Button>)
      }
    }
    </ThemeConfig.Consumer>
  );
};
export default PrimaryButton;
